import { Route } from '../../../shared/router';
import {
  ImageUploadPage,
  ArtCreatePage,
  EmailCheckpage,
  EmailSendPage,
  QuantityPage,
} from '../pages';

export const routes: Route[] = [
  {
    name: 'imageUpload',
    title: 'Image Upload',
    path: '/image-upload',
    component: ImageUploadPage,
    isPublic: false,
    onlyNonAuth: false,
    availableFor: 'consumer',
    layoutType: 'publicMain'
  },
  {
    name: 'ArtCreate',
    title: 'Art Create',
    path: '/art-create',
    component: ArtCreatePage,
    isPublic: false,
    onlyNonAuth: false,
    availableFor: 'consumer',
    layoutType: 'publicMain'
  },
  {
    name: 'SetQuantity',
    title: 'Set Quantity',
    path: '/quantity',
    component: QuantityPage,
    isPublic: false,
    onlyNonAuth: false,
    availableFor: 'consumer',
    layoutType: 'publicMain'
  },
  {
    name: 'email',
    title: 'E-Mail check',
    path: '/email',
    component: EmailCheckpage,
    isPublic: false,
    onlyNonAuth: false,
    availableFor: 'consumer',
    layoutType: 'publicMain'
  },
  {
    name: 'email',
    title: 'E-Mail send',
    path: '/email-send',
    component: EmailSendPage,
    isPublic: false,
    onlyNonAuth: false,
    availableFor: 'consumer',
    layoutType: 'publicMain'
  },
];
